<app-header [pageName]="pageName"></app-header>

<div class="register">
                <div class="row">
                    <div class="col-md-3 register-left">
                        <img src="../../assets/images/logo_white.png" alt=""/>
                        <h3>Welcome</h3>
                        <p>Weclome to Ganizani Market Event Sponsorship Application page</p>
                        <!-- <input (click)="onShowLogin()" type="submit" name="" value="Login"/><br/> -->
                    </div>

                    <div class="col-md-9 register-right">
                        <form class="form-signin" [formGroup]="applicationForm">
                            <h3 class="register-heading">Apply for Sponsorship</h3><br>

                            <div class="row register-form">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input formControlName="name" type="text" class="form-control" placeholder="Enter Event Name *" value="" />
                                    </div>
                                    <div class="form-group">
                                        <textarea fromControlName="description" class="form-control" id="desc" placeholder="Enter Description"></textarea>
                                    </div>
                                    <div class="form-group">
                                        <input formControlName="m_value" type="text" class="form-control" placeholder="Enter Market Value *" value="" />
                                    </div>
                                    <div class="form-group"> 
                                        <input formControlName="sp_name" type="text" class="form-control" placeholder="Enter Sponsor Name" value="" />
                                    </div>
                                    <div class="form-group"> 
                                        <input formControlName="attendance" type="text" class="form-control" placeholder="Enter Attendance Number" value="" />
                                    </div>
                                    <div class="form-group">
                                        <input formControlName="website" type="text" class="form-control"  placeholder="Enter Sponsor Website" value="" />    
                                    </div>
                                    <div class="form-group">
                                        <input formControlName="market" type="text" class="form-control"  placeholder="Enter Market" value="" />    
                                    </div>

                    
                                    <!-- <div class="form-group">
                                        <label class="btn btn-normal">
                                            <input type="file" (change)="selectFile($event)" id="file" class="file">
                                        </label>
                                    </div> -->
                                    
                                      
                                      <!-- <button class="btn btn-success" [disabled]="!selectedFiles" (click)="upload()">Upload logo</button><br><br> -->

                                
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input formControlName="email" type="email" class="form-control" placeholder="Enter Email" value="" />
                                    </div>
                                    <div class="form-group">
                                        <input formControlName="amount" type="text" class="form-control" placeholder="Rights Fees" value="" />
                                    </div>
                                    <div class="form-group">
                                        <input formControlName="duration" type="text" class="form-control" placeholder="Enter Duration Period(in days)" value="" />
                                    </div>
                                    <div class="form-group">
                                        <input formControlName="period" type="text" class="form-control" placeholder="Enter Period Estimate" value="" />
                                    </div>
                                    <div class="form-group">
                                        <input formControlName="contact" type="text" minlength="10" maxlength="10" name="txtEmpPhone" class="form-control" placeholder="Enter Cell/Phone Number" value="" />
                                    </div>
                                    <div class="form-group">
                                        <select  formControlName="category" class="form-control" >
                                            <option class="hidden"  selected disabled>Please select Category type</option>
                                            <option [ngValue]="category" *ngFor="let category of categories">{{ category }}</option>
                                        </select>
                                    </div>

                                    <div class="form-group">
                                        <select  formControlName="location" class="form-control">
                                            <option class="hidden" selected disabled>Please select Location</option>                                          
                                            <option [ngValue]="location" *ngFor="let location of locations">{{ location }}</option>
                                        </select>
                                    </div>

                                    <div class="form-group">
                                        <select  formControlName="date" class="form-control">
                                            <option class="hidden"  selected disabled>Please select Month/Date</option>
                                            <option [ngValue]="month" *ngFor="let month of months">{{ month }}</option>
                        
                                        </select> 
                                    </div>

                                    <input (click)="apply()" class="btnRegister"  value="Apply"/>
                                </div>
                                <div class="alert alert-success" role="alert" *ngIf="successMessage">
                                    {{ successMessage }}
                                </div>
                                <div class="alert alert-dange" role="alert" *ngIf="errorMessage">
                                    {{ errorMessage }}
                                </div>
                                
                            </div>
                        </form>

                        <!-- <form class="form-signin" [formGroup]="loginForm">
                            <div *ngIf="loginVisible">
                                <h3  class="register-heading">Login</h3>
                                <div class="row register-form">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <input formControlName="name" type="text" class="form-control" placeholder="Username" value="" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <input formControlName="password" type="password" class="form-control" placeholder="Password" value="" />
                                        </div>
                                        <input type="submit" class="btnRegister"  value="Login"/>
                                    </div>
                                </div>
                            </div>
                            <div class="alert alert-success" role="alert" *ngIf="successMessage"
                            style="background-color: aqua; margin-left: 10%">
                                {{ successMessage }}
                        </div>
                        <div class="alert alert-dange" role="alert" *ngIf="errorMessage"
                            style="background-color:brown; margin-left: 10%;">
                                {{ errorMessage }}
                        </div>
                        </form> -->
                    </div>
                </div>

            </div>
